<template>
  <v-container style="max-width: 1024px" class="mb-16">
    <!-- Debt Solutions Header -->
    <v-row class="text-white mt-4" align-content="center">
      <v-col cols="auto" class="pr-0 pb-0 mr-0 mt-1">
        <v-img
          :width="55"
          :height="40"
          alt="Debt Solutions Icon"
          src="./assets/debt-solutions-icon.svg"
        />
      </v-col>
      <v-col class="pl-0 pb-5 mt-2 pr-0">
        <h1 role="heading" aria-level="1" class="heading_two">
          {{ $t('L_my_primerica_debt_solution') }}
        </h1>
      </v-col>
    </v-row>

    <v-row class="mt-0 pt-0 mb-16">
      <v-col cols="12">
        <!-- Tabs for My Debt, My Plan, Learn More -->
        <v-sheet>
          <v-tabs
            grow
            slider-color="primary"
            class="pri-tabs"
            aria-orientation="horizontal"
            v-model="activeTab"
          >
            <v-tab
              @click="$router.replace({ name: RouteNames.MY_DEBT })"
              :class="activeTab === 0 ? 'colorselected' : 'colorunselected'"
            >
              <p :class="$vuetify.display.xs ? 'text-h6' : 'text-h4'">{{ $t('L_my_debt') }}</p>
            </v-tab>
            <v-tab
              @click="$router.replace({ name: RouteNames.MY_PLAN })"
              :class="activeTab === 1 ? 'colorselected' : 'colorunselected'"
            >
              <p :class="$vuetify.display.xs ? 'text-h6' : 'text-h4'">{{ $t('L_my_plan') }}</p>
            </v-tab>
            <v-tab
              @click="$router.replace({ name: RouteNames.LEARN_MORE_DEBT })"
              :class="activeTab === 2 ? 'colorselected' : 'colorunselected'"
            >
              <p :class="$vuetify.display.xs ? 'text-h6' : 'text-h4'">{{ $t('L_learn_more') }}</p>
            </v-tab>
          </v-tabs>
          <v-tabs-window v-model="activeTab" class="pri-tab-items">
            <v-tabs-window-item>
              <MyDebtTab @changeTab="changeTab" />
            </v-tabs-window-item>
            <v-tabs-window-item>
              <MyPlanTab @changeTab="changeTab" />
            </v-tabs-window-item>
            <v-tabs-window-item>
              <LearnMoreTab @changeTab="changeTab" />
            </v-tabs-window-item>
          </v-tabs-window>
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import { mapState, mapStores } from 'pinia';
import { usePolicyStore } from '../policy/store/policy.store';
import MyDebtTab from './components/MyDebtTab.vue';
import MyPlanTab from './components/MyPlanTab.vue';
import LearnMoreTab from './components/LearnMoreTab.vue';
import { RouteNames } from '@/router/routeNames';

const componentOptions: ComponentOptions = {
  name: 'DebtSolutionsPage',
  components: {
    MyDebtTab,
    MyPlanTab,
    LearnMoreTab,
  },
  data: () => ({
    activeTab: 0,
    RouteNames,
  }),
  mounted() {
    this.activeTab = this.activeTabRoute;
  },
  computed: {
    ...mapStores(usePolicyStore),
    ...mapState(usePolicyStore, ['currentPolicy']),
    activeTabRoute() {
      const tabs = {
        MyDebt: 0,
        MyPlan: 1,
        LearnMoreDebt: 2,
      } as Record<string, number>;
      return tabs[this.$route.name] || 0;
    },
  },
  methods: {
    changeTab(tabIndex: number) {
      this.activeTab = tabIndex;
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss">
.colorselected {
  background-color: #e2f0fe !important;
  color: #063562 !important;
  border-bottom: 2px solid #063562 !important;
}
.colorunselected {
  color: #000000 !important;
  border-bottom: 4px solid #cccccc !important;
}
</style>
